import styled from "styled-components";
import { DataGrid } from "@mui/x-data-grid";

export const NoRowsOverlayWrap = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const CustomDataGrid = styled(DataGrid)`
  &.MuiDataGrid-root {
    border: none;
    width: 100%;
    height: calc(100vh - 230px);
    outline: none !important;
  }

  & div:focus {
    outline: none !important;
  }

  & .MuiDataGrid-cell:focus,
  .MuiDataGrid-cell:focus-within {
    outline: none !important;
  }

  & .Mui-selected {
    background-color: transparent !important;
  }

  & .Mui-checked {
    color: #6750a4 !important;
  }

  & .MuiDataGrid-columnHeaderTitle {
    font-weight: 700;
  }

  & .MuiDataGrid-row {
    min-height: 52px !important;
    max-height: fit-content !important;
    height: auto !important;
  }

  // & .MuiDataGrid-columnHeaders .MuiSvgIcon-root {
  //   display:none;
  // }

  & .MuiDataGrid-columnHeaders:first-child {
    justify-content: center !important;
    margin: 0 !important;
  }

  &
    .MuiDataGrid-columnHeader[data-field="number"]:first-child
    .MuiDataGrid-columnHeaderTitleContainer {
    justify-content: center !important;
    margin: 0 !important;
  }

  &
    .MuiDataGrid-columnHeader[data-field="number"]:first-child
    .MuiDataGrid-columnHeaderDraggableContainer {
    width: calc(100% - 10px) !important;
  }

  // & .MuiDataGrid-cell {
  //   min-height: 52px !important;
  //   max-height: fit-content !important;
  //   height: auto !important;
  //   padding: 6px !important;
  //   white-space: inherit !important;
  // }

  & .MuiButtonBase-root {
    color: #6a6a6a;
  }

  // & .MuiButtonBase-root[title="Menu"] {
  //   color: red;
  //   display: none;
  // }

  // & .columnHeader--filtered {
  //   color: red !important;
  // }

  & .MuiTablePagination-selectLabel,
  .MuiTablePagination-root,
  .MuiTablePagination-displayedRows {
    font-size: 12px !important;
  }

  & .hover-cursor-default:hover {
    cursor: default;
  }

  & .hover-cursor-point:hover {
    cursor: pointer;
  }
`;

export const StyleDataGrid = styled(DataGrid)`
  & .MuiDataGrid-iconSeparator {
    display: none !important;
  }

  & .MuiDataGrid-columnHeaders {
    background: #ccc;
  }

  & .MuiDataGrid-columnHeaders .MuiSvgIcon-root {
    // display: none;
  }

  &
    .MuiDataGrid-columnHeaders
    .MuiSvgIcon-root[data-testid="CheckBoxOutlineBlankIcon"],
  &
    .MuiDataGrid-columnHeaders
    .MuiSvgIcon-root[data-testid="IndeterminateCheckBoxIcon"],
  & .MuiDataGrid-columnHeaders .MuiSvgIcon-root[data-testid="CheckBoxIcon"] {
    display: block !important;
  }

  & .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon {
    // display: none !important;
  }

  &
    .MuiDataGrid-columnHeader[data-field="number"]:first-child
    .MuiDataGrid-columnHeaderTitleContainer {
    justify-content: center !important;
    margin: 0 !important;
  }

  &
    .MuiDataGrid-columnHeader:first-child
    .MuiDataGrid-columnHeaderTitleContainer {
    justify-content: center;
  }

  & .MuiButtonBase-root {
    color: #6a6a6a;
  }

  /* AI Review: vertically center ungrouped column headers across the
     doubled-height column header area created by columnGrouping.
     Assumes default MUI X v5 headerHeight=56. */
  & .MuiDataGrid-columnHeader.ai-ungrouped-header {
    margin-top: -56px;
    height: calc(100% + 56px) !important;
    align-items: center;
  }

  & .is-reviewer {
    background: #fce6cd !important;
  }
  & .is-rejected {
    background: #efefef !important;
  }
  & .is-published {
    background: #d0e1f3 !important;
  }
  & .is-warning {
    background-color: red !important;
    animation: blink 1s infinite;
  }

  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
